import React from 'react';
import { View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import colors from '@/design/colors';

interface HeadingInfo {
  name: string;
  value: string;
}

interface Props {
  title: string;
  photo?: string;
  infos?: HeadingInfo[];
}

const styles = StyleSheet.create({
  panel: {
    flexDirection: 'row',
    alignItems: 'center',

    borderRadius: 4,
    border: `2px solid ${colors.gray100}`,
    backgroundColor: colors.gray50,
  },
  photo: {
    width: '30%',
    maxHeight: 86,
    objectFit: 'contain',
    padding: 12,
  },
  heading: {
    flexDirection: 'column',
    rowGap: 4,
    padding: 12,
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
    textTransform: 'uppercase',
    marginBottom: 8,
  },
  info: {
    flexDirection: 'row',
    columnGap: 4,
    fontSize: 10,
  },
  infoName: {
    fontWeight: 600,
  },
});

const DocumentHeading: React.FC<Props> = ({ title, photo, infos = [] }) => {
  const divider = React.useMemo(() => {
    if (photo) {
      return { borderLeft: `2px solid ${colors.gray100}` };
    }

    return {};
  }, [photo]);

  return (
    <View style={styles.panel}>
      {photo && <Image style={styles.photo} src={photo} />}

      <View style={[styles.heading, divider]}>
        <Text style={styles.title}>{title}</Text>

        {infos.map(info => (
          <View key={info.name} style={styles.info}>
            <Text style={styles.infoName}>{info.name}:</Text>
            <Text>{info.value}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};

export default DocumentHeading;
